module.exports = __webpack_public_path__ + "front/img/edm-banner.b9f5bc18.png";